<!--- COMPONENTE UCUnidadMedidaKiloYEnvase  ---->
<!---
Descripción del componente:
---------------------------
- Permite introducir una cantidad en kilos y la cantidad de envases.

Eventos del componente:
-----------------------
-
Plantillas de Diseño:
-----------------------
- P1 -> Por Defecto
- P2 ->
-->

<template>
  <div class="div-componenteUCUnidadMedidaKiloYEnvase">
    <!------- PLANTILLA  DISEÑO P1 -------------->
    <!---------------------------------------->
    <div
      v-if="plantilla == null || plantilla === 'P1'"
      class="div-p1"
    >
      <f7-row>
        <f7-col width="50">
          <div>
            <form @submit.prevent="CantidadEnvasesModificadoManualmente">
              <div
                v-if="mostrarTitulo"
                class="div-ttlElemento"
              >
                <span class="span-ttlElemento">
                  {{ $t('common.packages') }}
                </span>
              </div>
              <f7-row>
                <f7-col width="100">
                  <div class="div-campoDeEntrada">
                    <input
                      type="number"
                      :disabled="deshabilitarInputComponente"
                      class="input-cantidades"
                      :value="cantidadEnvases"
                      accept="number"
                      min="1"
                      @input="valorEnvasesModificacionManual = $event.target.value"
                      @focus="EstablecerModo('envase')"
                      @focusout="CantidadEnvasesModificadoManualmente"
                    >
                  </div>
                </f7-col>
              </f7-row>
            </form>
          </div>
        </f7-col>
        <f7-col width="50">
          <div>
            <form @submit.prevent="">
              <div
                v-if="mostrarTitulo"
                class="div-ttlElemento"
              >
                <span class="span-ttlElemento">
                  {{ $t('common.kilos') }}
                </span>
              </div>
              <f7-row>
                <f7-col width="100">
                  <div class="div-campoDeEntrada">
                    <input
                      type="number"
                      class="input-cantidades"
                      :disabled="deshabilitarInputComponente"
                      :value="cantidadKilos"
                      accept="number"
                      min="1"
                      step="any"
                      @input="valorKilosModificacionManual = $event.target.value"
                      @focus="EstablecerModo('kilo')"
                      @focusout="CantidadKilosModificadoManualmente"
                    >
                  </div>
                </f7-col>
              </f7-row>
            </form>
          </div>
        </f7-col>
      </f7-row>
    </div>

    <!------- PLANTILLA  DISEÑO P2 -------------->
    <!---------------------------------------->

    <div
      v-if="plantilla === 'P2'"
      class="div-p2"
      :class="{ 'div-p2-disabled': deshabilitarInputComponente }"
    >
      <f7-row>
        <f7-col
          width="45"
          class="col-elementoEnvases"
        >
          <div>
            <form @submit.prevent="CantidadEnvasesModificadoManualmente">
              <div
                v-if="mostrarTitulo"
                class="div-ttlElemento-P2"
              >
                <span class="span-ttlElemento-P2">
                  {{ $t('common.packages') }}
                </span>
              </div>
              <f7-row>
                <f7-col width="100">
                  <div class="">
                    <div class="stepper stepper-init stepper-fill stepper-large">
                      <div
                        class="stepper-button-minus"
                        :class="{ 'stepper-button-minus-disabled': deshabilitarInputComponente }"
                        @click="CantidadEnvasesDecrementada"
                      />
                      <div class="stepper-input-wrap">
                        <input
                          :id="`input-cantidadEnvases-${idElemento}`"
                          type="number"
                          :min="0"
                          :disabled="deshabilitarInputComponente || deshabilitarInputEnvases"
                          :value="cantidadEnvases"
                          @input="valorEnvasesModificacionManual = $event.target.value"
                          @focus="EstablecerModo('envase')"
                          @focusout="CantidadEnvasesModificadoManualmente"
                        >
                      </div>
                      <div
                        class="stepper-button-plus"
                        :class="{ 'stepper-button-plus-disabled': deshabilitarInputComponente }"
                        @click="CantidadEnvasesIncrementada"
                      />
                    </div>
                  </div>
                </f7-col>
              </f7-row>
            </form>
          </div>
        </f7-col>
        <f7-col
          width="10"
          class="col-elementoEnvases"
        >
          <span
            class="btn-oval-autocalculos seleccionable"
            @click="HabilitarDeshabilitarAutocalculoEnvasesYKilos()"
          > <img
              v-if="deshabilitarAutocalculo"
              alt="iconSuffleRed"
              src="@/static/icons/ic_suffle_red.svg"
              width="27px"
            >
            <img
              v-if="!deshabilitarAutocalculo"
              alt="iconSuffleGray"
              src="@/static/icons/ic_suffle_gray.svg"
              width="27px"
            >
          </span>
        </f7-col>
        <f7-col
          width="45"
          class="col-elementoKilos"
        >
          <div class="div-elementoKilos-P2">
            <form @submit.prevent="">
              <div
                v-if="mostrarTitulo"
                class="div-ttlElemento-P2"
              >
                <span class="span-ttlElemento-P2">
                  {{ $t('common.kilos') }}
                </span>
              </div>
              <f7-row>
                <f7-col width="100">
                  <div class="div-campoDeEntrada-P2">
                    <input
                      type="number"
                      class="input-cantidades-P2"
                      :disabled="deshabilitarInputComponente"
                      :value="cantidadKilos"
                      accept="number"
                      min="1"
                      validate
                      step="any"
                      @input="valorKilosModificacionManual = $event.target.value"
                      @focus="EstablecerModo('kilo')"
                      @focusout="CantidadKilosModificadoManualmente"
                    >
                  </div>
                </f7-col>
              </f7-row>
            </form>
          </div>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
// import eventBus from '@/js/event-bus';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';

export default {
  name: 'UCUnitMeasureKiloAndContainer',
  props: {
    activo: { type: Boolean, default: false },
    defaultEnvases: { type: Number, default: 0 },
    defaultKilos: { type: Number, default: 0 },
    mostrarTitulo: { type: Boolean, default: false },
    autocalculo: { type: Boolean, default: false }, // Por defecto false --> en true al introducir una cantidad de kilos calcula los envases y viceversa.
    deshabilitar: { type: Boolean, default: false },
    tag: { type: [String, Object], default: '' }, // Sera retornado en los eventos y sirve para identificar de donde se llamo.
    plantilla: { type: String, default: 'P1' },
    producto: { type: Object, default: null },
    envase: { type: Object, default: null },
    idElemento: { type: Number, default: 0 }, // Para asignar un id a los elementos (se utiliza cuando se añade el componente multipes veces en un frm)
    modoAutoCalculo: { type: String, default: 'CAPACIDADESENVASE' },
    capacidadProductoPorEnvase: { type: Number, default: 0 }, // Si se establece este valor prevalecerá frente al resto de auto cálculos.
    sinMaximo: { type: Boolean, default: false },
  },

  emits: ['cantidadEnvasesYKilosModificada'],

  data() {
    return {
      MODOSCOMPONENTE: {
        ENVASE: 'envase',
        KILO: 'kilo',
      }, // Controla el modo del componente
      modoComponente: null,
      MODOSAUTOCALCULO: {
        CALCULARPORCAPACIDADESENVASE: 'CAPACIDADESENVASE', // Utiliza las CantidadesNormalizadasPorEnvaseYProducto que cargamos al abrir la APP. Tienen que definirse producto y envase.
        CALCULARPORPROPORCIONES: 'PROPORCIONES', // Calcula la cantidad en función del defaultEnvases/defaultKilos definido.
      }, // Controla el modo del componente
      cantidadEnvases: 0,
      cantidadKilos: 0,
      kilosPorEnvase: 0, // Mantiene los kilos por caja del elemento seleccionado.
      deshabilitarInputComponente: false, // Controla que los Input permitan ser modificados.
      deshabilitarAutocalculo: false, // Prevale sobre la propiedad pasada. FALSE= HABILITADO
      valorEnvasesModificacionManual: 0,
      valorKilosModificacionManual: 0,
      deshabilitarInputEnvases: false,

    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'cantidadesNormalizadasPorEnvaseYProducto',
      'articulosDeTipoEnvase',
    ]),
  },
  watch: {
    activo(val) {
      if (val) {
        this.InicializarComponente();
      }
    },
    cantidadEnvases() {
      if (this.modoComponente === this.MODOSCOMPONENTE.ENVASE && this.deshabilitarAutocalculo === false && this.autocalculo != null && this.autocalculo === true) {
        this.AutocalcularCantidadKilos();
      }
      this.NotificarCambiosEnCantidades();
    },
    cantidadKilos() {
      if (this.modoComponente === this.MODOSCOMPONENTE.KILO && this.deshabilitarAutocalculo === false && this.autocalculo != null && this.autocalculo === true) {
        this.AutocalcularCantidadEnvases();
      }
      this.NotificarCambiosEnCantidades();
    },
    defaultKilos() {
      this.InicializarComponente();
    },
    defaultEnvases() {
      this.InicializarComponente();
    },
    capacidadProductoPorEnvase(newVal, oldVal) {
      if (this.deshabilitar) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      this.CalcularKilosContenidosEnUnEnvase();
    },
    envase(newVal, oldVal) {
      if (this.deshabilitar) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      if (newVal != null && this.capacidadProductoPorEnvase === 0) {
        this.CalcularKilosContenidosEnUnEnvase();
      }
    },
    producto(newVal, oldVal) {
      if (this.deshabilitar) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      if (newVal != null && this.capacidadProductoPorEnvase === 0) {
        this.CalcularKilosContenidosEnUnEnvase();
      }
    },
    modoAutoCalculo(val) {
      if (val != null && val !== undefined) {
        this.modoAutocalculoComponente = val;
      }
    },
    deshabilitar() {
      this.InicializarComponente();
    },
  },

  mounted() {
    this.InicializarComponente();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      if (Number.isNaN(this.defaultEnvases)) {
        this.cantidadEnvases = 0;
      } else {
        this.cantidadEnvases = Number(this.defaultEnvases);
      }
      this.kilosPorEnvase = this.CalcularKilosContenidosEnUnEnvase();
      this.cantidadKilos = Number(this.defaultKilos);
      this.calculoEnvases = this.cantidadEnvases;
      this.valorKilosModificacionManual = this.cantidadKilos;
      this.valorEnvasesModificacionManual = this.cantidadEnvases;
      if (this.deshabilitar) {
        this.DeshabilitarInputComponente();
      } else {
        this.HabilitarInputComponente();
      }
    },
    /** Método CalcularKilosContenidosEnUnEnvase */
    CalcularKilosContenidosEnUnEnvase() {
      Log(this, this.CalcularKilosContenidosEnUnEnvase.name);
      if (this.capacidadProductoPorEnvase !== 0) {
        this.kilosPorEnvase = this.capacidadProductoPorEnvase;
        return this.capacidadProductoPorEnvase;
      }
      if (this.producto != null && this.envase != null) {
        this.kilosPorEnvase = this.ObtenerPesoPorEnvaseYProducto();
        return this.kilosPorEnvase;
      }
      this.kilosPorEnvase = this.defaultKilos / this.defaultEnvases;
      return this.kilosPorEnvase;
    },
    /** Método NotificarCambiosEnCantidades */
    NotificarCambiosEnCantidades() {
      Log(this, this.NotificarCambiosEnCantidades.name);
      if (!this.ValidarCantidades()) {
        // eventBus.emit('UCUnidadMedidaKiloYEnvase_cantidadModificada', 0, 0); // Cantidad Indicada no valida
        this.$emit('cantidadEnvasesYKilosModificada', {
          Tag: this.tag,
          CantidadEnvasesModificado: this.cantidadEnvases,
          CantidadKilosModificado: this.cantidadKilos,
        });
        return;
      }
      // eventBus.emit('UCUnidadMedidaKiloYEnvase_cantidadModificada', this.cantidadKilos, this.cantidadEnvases);
      this.$emit('cantidadEnvasesYKilosModificada', {
        Tag: this.tag,
        CantidadEnvasesModificado: this.cantidadEnvases,
        CantidadKilosModificado: this.cantidadKilos,
      });
    },
    /** Método ValidarCantidades */
    ValidarCantidades() {
      Log(this, this.ValidarCantidades.name);
      // Validamos la cantidad de Kilos
      if (this.cantidadKilos === '') {
        Log(this, 'Cantidad de Kilos vacia');
        return false;
      }
      // Validamos la cantidad de Envases
      if (this.cantidadEnvases === '') {
        Log(this, 'Cantidad de envases vacia');
        return false;
      }
      return true;
    },

    EstablecerModo(modo) {
      Log(this, this.EstablecerModo.name);
      if (modo === this.MODOSCOMPONENTE.ENVASE) {
        this.modoComponente = this.MODOSCOMPONENTE.ENVASE;
      }
      if (modo === this.MODOSCOMPONENTE.KILO) {
        this.modoComponente = this.MODOSCOMPONENTE.KILO;
      }
    },

    AutocalcularCantidadEnvases() {
      Log(this, this.AutocalcularCantidadEnvases.name);
      if (this.modoAutoCalculo === this.MODOSAUTOCALCULO.CALCULARPORPROPORCIONES) {
        this.kilosPorEnvase = this.defaultKilos / this.defaultEnvases;
      }
      this.cantidadEnvases = this.cantidadKilos / this.kilosPorEnvase;
      this.cantidadEnvases = Math.trunc(this.cantidadEnvases); // Quita la parte decimal
      this.valorEnvasesModificacionManual = this.cantidadEnvases;
    },

    /**
     * @public
     * @returns {void}
     */
    AutocalcularCantidadKilos() {
      Log(this, this.AutocalcularCantidadKilos.name);
      if (this.modoAutoCalculo === this.MODOSAUTOCALCULO.CALCULARPORPROPORCIONES) {
        this.kilosPorEnvase = this.defaultKilos / this.defaultEnvases;
      }
      this.cantidadKilos = this.cantidadEnvases * this.kilosPorEnvase;
      this.cantidadKilos = this.cantidadKilos.toFixed(2);
      this.valorKilosModificacionManual = this.cantidadKilos;
    },

    DeshabilitarInputComponente() {
      Log(this, this.DeshabilitarInputComponente.name);
      this.deshabilitarInputComponente = true;
    },

    HabilitarInputComponente() {
      Log(this, this.HabilitarInputComponente.name);
      this.deshabilitarInputComponente = false;
    },

    CantidadEnvasesIncrementada() {
      Log(this, this.CantidadEnvasesIncrementada.name);
      const valParse = Number.parseInt(this.cantidadEnvases, 10);
      this.cantidadEnvases = valParse + 1;
      this.EstablecerModo('envase');
    },

    CantidadEnvasesDecrementada() {
      Log(this, this.CantidadEnvasesDecrementada.name);
      this.cantidadEnvases -= 1;
      this.EstablecerModo('envase');
    },

    ObtenerPesoPorEnvaseYProducto() {
      Log(this, this.ObtenerPesoPorEnvaseYProducto.name);
      if (this.envase == null || this.producto == null) {
        return 1;
      }
      // Utilizamos las CantidadesNormalizadasPorEnvaseYProducto que cargamos al abrir la APP para buscar la que corresponda con nuestro
      // Envase y nuestro acticulo seleccionado, sino tenemos estas cantidades por algun motivo utilizara la CantidadKilosPorEnvase definida en el envase.
      const { cantidadesNormalizadasPorEnvaseYProducto } = this;
      let listObjCantidadPorEnvase = null;
      if (cantidadesNormalizadasPorEnvaseYProducto != null) {
        listObjCantidadPorEnvase = cantidadesNormalizadasPorEnvaseYProducto.filter((e) => e.Envase.Id === this.envase.Id && e.Articulo.Id === this.producto.Id);
      }
      if (listObjCantidadPorEnvase != null && listObjCantidadPorEnvase.length > 0) {
        const objCantidadPorEnvase = listObjCantidadPorEnvase[0];

        this.kilosPorEnvase = objCantidadPorEnvase.Cantidad;
      } else if (Object.hasOwn(this.envase, 'CantidadKilosPorEnvase') && this.envase.CantidadKilosPorEnvase !== '') {
        this.kilosPorEnvase = this.envase.CantidadKilosPorEnvase;
      } else {
        // Obtenemos la cantidad de kilos por envase de los envases almacenados.
        const tempArticulosTipoEnvase = this.articulosDeTipoEnvase;
        let tempEnvase = null;
        if (tempArticulosTipoEnvase != null) {
          [tempEnvase] = tempArticulosTipoEnvase.filter((e) => e.Id === this.envase.Id);
        }
        // Sino tenemos ninguna cantidad mostramos un mensaje pero la establecemos a 1 para los autocalculos.
        if (tempEnvase === null || tempEnvase === undefined || tempEnvase.CantidadKilosPorEnvase == null || tempEnvase.CantidadKilosPorEnvase === 0) {
          this.kilosPorEnvase = 1;
        } else {
          this.kilosPorEnvase = tempEnvase.CantidadKilosPorEnvase; // Tenemos cantidad definida en el envase.
        }
      }
      return this.kilosPorEnvase;
    },

    HabilitarDeshabilitarAutocalculoEnvasesYKilos() {
      Log(this, this.HabilitarDeshabilitarAutocalculoEnvasesYKilos.name);
      this.deshabilitarAutocalculo = !this.deshabilitarAutocalculo;
      this.deshabilitarInputEnvases = this.deshabilitarAutocalculo; // La entrada manual de envases da problemas se debe hacer con los + -
    },

    CantidadEnvasesModificadoManualmente() {
      /*
      // const valorInt = Number.parseInt(value, 10);
      if (value === '') {
        this.cantidadEnvases = null;
        this.cantidadEnvases = 0;
      } else if (value < 0) {
        this.cantidadEnvases = null;
        this.cantidadEnvases = 0;
      } else if (value > this.defaultEnvases) {
        this.cantidadEnvases = null;
        this.cantidadEnvases = this.defaultEnvases;
      } else {
        this.cantidadEnvases = value;
      }
      */
      if (!this.sinMaximo && this.valorEnvasesModificacionManual > this.maxEnvases) {
        this.valorEnvasesModificacionManual = this.cantidadEnvases;
        this.cantidadEnvases = 0; // Para que no se quede en el valor anterior.
        this.cantidadEnvases = this.valorEnvasesModificacionManual;
        HiNotification.Toast(this.$t('production.unitMeasureKilo.maxPackagesToastText', { number: this.maxEnvases }));
        return;
      }

      this.cantidadEnvases = this.valorEnvasesModificacionManual;
    },

    CantidadKilosModificadoManualmente() {
      if (!this.sinMaximo && this.valorKilosModificacionManual > this.maxKilos) {
        this.valorKilosModificacionManual = this.cantidadKilos;
        this.cantidadKilos = 0; // Para que no se quede en el valor anterior.
        this.cantidadKilos = this.valorKilosModificacionManual;
        HiNotification.Toast(this.$t('production.unitMeasureKilo.maxKilosToastText', { number: this.maxKilos }));
        return;
      }
      this.cantidadKilos = this.valorKilosModificacionManual;
    },
  },
};
</script>

<style scoped>
/********* DISEÑOS COMUNES Y PLANTILLA P1 ***********/

/*****************************************  */

.div-campoDeEntrada {
  background: #fff;
  margin-right: 4px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.input-cantidades {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #009ba6;
  font-size: 24px;
  margin-top: 15px;
  margin-bottom: 16px;
}

.span-ttlElemento {
  color: var(--his-darkgray);
  font-size: 14px;
  font-weight: 500;
}

.div-ttlElemento {
  padding-left: 25px;
}

/********* DISEÑOS PLANTILLA P2 ***********/

/*****************************************  */

.div-p2-disabled {
  opacity: 0.8;
  pointer-events: none;  /** El Click no funcionara sobre el div si esta disabled */
}

.stepper-button-minus,
.stepper-button-plus {
  background-color: var(--his-slate-blue) !important;
  border-color: var(--his-slate-blue) !important;
}

.stepper-button-minus-disabled,
.stepper-button-plus-disabled {
  background-color: var(--his-slate-blue) !important;
  border-color: var(--his-slate-blue) !important;
  opacity: 0.9;
}

input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.stepper-input-wrap input {
  color: var(--his-slate-blue) !important;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.stepper-input-wrap {
  border-top: 2px solid var(--his-slate-blue);
  border-bottom: 2px solid var(--his-slate-blue);
}

.div-deshabilitarAutocalculo {
  display: flex;
  align-items: center;
  text-align: center;
}

.div-campoDeEntrada-P2 {
  box-sizing: border-box;
  height: 37px;
  width: 90px;
  background: #fff;
  border: 1px solid var(--his-silver);
  background-color: #fff;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 8px;
}

.input-cantidades-P2 {
  width: 90px;
  text-align: center;
  color: var(--his-slate-blue);
  font-size: 24px;
  margin-top: 2px;
  margin-bottom: 2px;
}

.div-ttlElemento-P2 {
  padding-left: 0;
}

.col-elementoKilos {
  text-align: center;
  margin-top: 7px;
}

.div-elementoKilos-P2 {
  width: 100px;
}

.col-elementoEnvases {
  text-align: center;
}

.span-ttlElemento-P2 {
  color: var(--his-oliva);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
}

.btn-oval-autocalculos {
  background-color: #f4f5f7;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  min-height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
}
</style>
